var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupercenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5462,
    cy: 25,
    rx: 24.8077,
    ry: 25,
    fill: "#FF0000",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6384 37H36.9868",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3938 21.3137V26.5425",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3938 29.1569V34.3856",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2314 21.3137V26.5425",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2314 29.1569V34.3856",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5571 17.3922H34.0684V37.0001H16.5571V17.3922Z",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5571 14C16.5571 12.8954 17.4526 12 18.5571 12H32.0684C33.173 12 34.0684 12.8954 34.0684 14V17.8824H16.5571V14Z",
    stroke: "#FF0000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupercenter);
export default __webpack_public_path__ + "static/media/supercenter.649761b0d4ac770eaa3fe0ca04005db0.svg";
export { ForwardRef as ReactComponent };